/* formValidation.js */
import { formvalidator_translations, password_strength_translations } from "./formValidatorTranslations.js";
import FormValidationRules from "./formValidationRules.js";
import * as PasswordStrengthCalculator from "./passwordStrengthCalculator.js";

export default (el) => {
    const lang = el.dataset.lang || 'en_us';
    const submitButton = el.querySelector('[type=submit]');
    const fields = el.querySelectorAll('input:not([type=hidden]):not([disabled]):not([readonly]), ' +
        'textarea:not([disabled]):not([readonly]), ' +
        'select:not([disabled]):not([readonly])'
    );

    if (!el.dataset.lang && !el.dataset.translations) {
        console.warn('form-element is missing a data-lang');
    }

    let messageTranslations = formvalidator_translations[lang];

    if (el.dataset.translations) {
        messageTranslations = JSON.parse(el.dataset.translations);
    }

    fields.forEach((field) => {
        if (field.type === "password" && field.required === true && field.dataset.validation !== "false") {
            field.addEventListener('blur', function(){
                // Validate this field and pass translations for validator message
                let validate = new FormValidationRules(this, {messages: messageTranslations, showSuccess: true});
            });
        } else if (field.type === "password" && field.required === false && field.dataset.validation !== "false") {
            field.addEventListener('keyup', function(){
                let validate = new PasswordStrengthCalculator(this, {passwordTier: password_strength_translations[lang]});
            });
        } else {
            field.addEventListener('blur', function(){
                let validate = new FormValidationRules(this, {messages: messageTranslations, showSuccess: true});
            });
        }
    });

    // Validate form on submit
    submitButton.addEventListener('click', function(fields, el, e){
        let formIsValid = true;

        // Loop each field
        fields.forEach((field) => {
            // Pass translations for validator message
            let fieldToValidate = new FormValidationRules(field, {messages: messageTranslations, showSuccess: true});
            if (!fieldToValidate.isValid) {
                formIsValid = false;
            }
        });

        if (!formIsValid) {
            e.preventDefault();
            el.querySelector('.-invalid').querySelector('input, textarea, select').focus();
        }
    }.bind(this, fields, el));
};
